<div class="container-fluid">
  <div class="row">
    <iframe
      id="tokenFrame"
      name="tokenFrame"
      src="https://fts.cardconnect.com:443/itoke/ajax-tokenizer.html?css=html%2Cbody%2Cform%7Bpadding%3A0px%3Bmargin%3A0px%3B%7Dinput%7Bheight%3A30px%3Bwidth%3A220px%3B%7D.error%7Bcolor%3Ared%3Bborder-color%3Ared%3B%7D&invalidinputevent=true"
      frameborder="0"
      scrolling="no"
      width="225"
      height="40"
    ></iframe>
    <!--
            for test accounts
            <iframe id="tokenFrame" name="tokenFrame" src="https://fts.cardconnect.com:6443/itoke/ajax-tokenizer.html?css=html,body,form{padding:0px;margin:0px;}input{height:30px;width:220px;}.error{color:red;border-color:red;}&invalidinputevent=true" frameborder="0" scrolling="no" width="225" height="40"></iframe>
        -->
  </div>
  <div class="row" *ngIf="tokenError != ''">
    <label>
      {{ tokenError }}
    </label>
  </div>
  <!--<div class="row" *ngIf="token != ''">
        <label>
            {{token}}
        </label>
    </div>-->
</div>
